import { useState } from 'react';
import type { MouseEvent } from 'react';
import classNames from 'classnames';

import IconButton from 'components/partials/button/icon-button';

import { useMarkPanelState } from '../mark-panel-context';
import { useMarkSurface } from '../mark-surface-context';
import type { MarkContextTarget } from '../mark-panel.types';

import MarkEmblem from './mark-emblem';

export interface MarkContextTriggerProps {
  target: MarkContextTarget;
  ariaLabel: string;
  className?: string;
}

const MarkContextTrigger = ({
  target,
  ariaLabel,
  className,
}: MarkContextTriggerProps) => {
  const markSurface = useMarkSurface();
  const pendingAnchor = useMarkPanelState()?.pendingOpen?.anchorElement;
  const [buttonElement, setButtonElement] = useState<HTMLButtonElement | null>(
    null
  );
  const isConfirmationOpen = !!buttonElement && pendingAnchor === buttonElement;

  if (!markSurface) return null;

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    markSurface.requestOpen(target, event.currentTarget);
  };

  return (
    <IconButton
      variant="reserve-text"
      size="md"
      icon={<MarkEmblem />}
      aria-label={ariaLabel}
      onClick={handleClick}
      ref={setButtonElement}
      className={classNames(
        'size-5 !p-0 !border-0 !rounded-full transition-opacity group-hover:opacity-100 group-has-[:focus-visible]:opacity-100',
        { 'opacity-0': !isConfirmationOpen },
        className
      )}
    />
  );
};

export default MarkContextTrigger;
